import * as React from 'react';

import { colors } from 'styles/cp';

export enum CARD_STATE {
  'SUCCESS' = 'SUCCESS',
  'WARNING' = 'WARNING',
}

export type Props = {
  state?: CARD_STATE;
  children?: React.ReactNode | string | null;
};

const StatusCard: React.FC<Props> = ({ state, children }: Props) => {
  const headerColor1 = state && state === CARD_STATE.SUCCESS ? colors.blue02 : colors.orange;
  const headerColor2 = state && state === CARD_STATE.SUCCESS ? colors.green02 : colors.orange;

  return (
    <React.Fragment>
      <div className="card-wrapper">
        {state && <div className="header-bar" />}
        <div className="card-body">{children}</div>
      </div>

      <style jsx>{`
        .card-wrapper {
          background-color: ${colors.white};
          border-radius: 4px;
          width: 100%;
          display: table;
          text-align: center;
        }
        .header-bar {
          height: 5px;
          line-height: 100px;
          background-image: linear-gradient(
            268.24deg,
            ${headerColor1} -9.58%,
            ${headerColor2} 155.59%
          );
          text-align: center;
          border-top-left-radius: inherit;
          border-top-right-radius: inherit;
        }
        .card-body {
          padding: 0px;
        }
      `}</style>
    </React.Fragment>
  );
};

export default StatusCard;
